export const SYNC_CONNECTIONS = {
  checkgappsconnected: {
    label: 'label.GOOGLE_DIRECTORY',
    value: 'checkgappsconnected',
    endpoint: 'syncgapps',
    supports: ['individual', 'users', 'groups', 'organizations']
  },
  checkftpconnected: {
    label: 'label.FTP_USERS',
    value: 'checkftpconnected',
    endpoint: 'syncftp',
    supports: ['users']
  },
  checktotalexpertconnected: {
    label: 'label.TOTAL_EXPERT_DIRECTORY',
    value: 'checktotalexpertconnected',
    endpoint: 'synctotalexpert',
    supports: ['users']
  },
  checksalesforceconnected: {
    label: 'label.SALESFORCE_DIRECTORY',
    value: 'checksalesforceconnected',
    endpoint: 'syncsalesforce',
    supports: ['users']
  },
  checkcustomdirconnected: {
    label: 'label.CUSTOM_DIRECTORY',
    value: 'checkcustomdirconnected',
    endpoint: 'synccustomdir',
    supports: ['users']
  },
  checkoutreachconnected: {
    label: 'label.OUTREACH_DIRECTORY',
    value: 'checkoutreachconnected',
    endpoint: 'syncoutreach',
    supports: ['users']
  },
  checkcalendlyconnected: {
    label: 'label.CALENDLY_DIRECTORY',
    value: 'checkcalendlyconnected',
    endpoint: 'synccalendly',
    supports: ['users']
  },
  checkbamboohrconnected: {
    label: 'label.BAMBOO_HR_DIRECTORY',
    value: 'checkbamboohrconnected',
    endpoint: 'syncbamboohr',
    supports: ['users']
  },
  checkfrontappconnected: {
    label: 'label.FRONT_DIRECTORY',
    value: 'checkfrontappconnected',
    endpoint: 'syncfrontapp',
    supports: ['users']
  },
  checkpingboardconnected: {
    label: 'label.PINGBOARD_DIRECTORY',
    value: 'checkpingboardconnected',
    endpoint: 'syncpingboard',
    supports: ['users']
  },
  checkairtableconnected: {
    label: 'label.AIRTABLE_DIRECTORY',
    value: 'checkairtableconnected',
    endpoint: 'syncairtable',
    supports: ['users']
  },
  checkmangoappsconnected: {
    label: 'label.MANGOAPPS_DIRECTORY',
    value: 'checkmangoappsconnected',
    endpoint: 'syncmangoapps',
    supports: ['users']
  },
  checkpaylocityconnected: {
    label: 'label.PAYLOCITY_DIRECTORY',
    value: 'checkpaylocityconnected',
    endpoint: 'syncpaylocity',
    supports: ['users']
  },
  checkoktaconnected: {
    label: 'label.OKTA_DIRECTORY',
    value: 'checkoktaconnected',
    endpoint: 'syncokta',
    supports: ['users', 'groups']
  },
  checkoneloginconnected: {
    label: 'label.ONELOGIN_DIRECTORY',
    value: 'checkoneloginconnected',
    endpoint: 'synconelogin',
    supports: ['users']
  },
  checko365connected: {
    label: 'label.AZURE_DIRECTORY',
    value: 'checko365connected',
    endpoint: 'synco365',
    supports: ['users', 'groups']
  }
  // ,checko365pusherconnected: {
  //   label: 'Azure Pusher Directory',
  //   value: 'checko365pusherconnected',
  //   endpoint: 'synco365',
  //   supports: ['users']
  // }
};
